import { create } from 'zustand';

// Create a store with Zustand for our email form
const useStore = create((set) => ({
  fromEmail: '',
  toEmail: '',
  isValidEmail: false,
  
  // Set the from email (username part)
  setFromEmail: (fromEmail) => set({ fromEmail }),
  
  // Set the to email with validation
  setToEmail: (toEmail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(toEmail);
    set({ toEmail, isValidEmail });
  },
  
  // Generate a random string for the from email
  generateRandomFrom: () => {
    const randomString = Math.random().toString(36).substring(2, 8);
    set({ fromEmail: randomString });
  },
  
  // Get the mailto link
  getMailtoLink: (state) => {
    if (!state.fromEmail || !state.toEmail || !state.isValidEmail) return '';
    
    // Extract the parts from the destination email
    const [username, domain] = state.toEmail.split('@');
    
    // Format: mailto:fromEmail+username=domain@haha.tech
    // Make sure to encode the components properly
    const encodedFrom = encodeURIComponent(state.fromEmail);
    const encodedUsername = encodeURIComponent(username);
    const encodedDomain = encodeURIComponent(domain);
    
    return `mailto:${encodedFrom}+${encodedUsername}=${encodedDomain}@haha.tech`;
  }
}));

export default useStore;
